export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const PUBLIC_CMS_URL = process.env.REACT_APP_PUBLIC_CMS_URL;

export const API_URL = {
  GET_META_DATA_LIST: '/meta-data',
  HEADER_MENU: '/header-menu',
  SEARCH_DESTINATION: '/search-destination',
  HOME_SLIDER: '/banner-slider',
  HOME_SLIDER2: '/state-wise-banner',
  BUSINESS_COUNT: '/business-count',
  INDIA_MUST_SEE_LIST: '/india-must-see',
  REVIEW_LIST: '/review',
  GET_FAQ_LIST: '/faq',
  THEME_LIST: '/theme',
  GET_ADVENTURES_LIST: '/get-adventures',
  GET_PACKAGE_LIST: '/get-package-list',
  GET_PACKAGE_DETAILS: '/get-package-details',
  SEARCH_CITIES: '/search-cities',
  SEARCH_COUNTRY: '/countries',
  CREATE_ENQUIRY: '/create-enquiry',
  ENQUIRY_OTP_VERIFY: '/enquiry-otp-verify',
  GET_REVIEW_GALLERY: '/review-gallery',
  WHY_INDIA_LIST: '/why-india'
};

export const IMAGE_DIR_PATH = {
  HOME_BANNER_SLIDER_PATH: '/bannerslider/',
  HOME_BANNER_SLIDER_PATH1: '/hiddengems/',
  INDIA_MUST_SEE_PATH: '/indiamustsee/',
  WHY_INDIA_PATH: '/whyindia/',
  REVIEW_LIST_PATH: '/inboundreview/',
  USER_PROFILE_PIC_PATH: '/user/'
};
